export default "__VITE_ASSET__BJMdoHm1__"